module.exports = __webpack_public_path__ + "static/media/LACBA Logo_1591008977835.b2ef262b.jpg";